// extracted by mini-css-extract-plugin
export default {"Modal":"NewSponsor_Modal__pELr4","personSearchOverride":"NewSponsor_personSearchOverride__LC8UU"};